import { StructureDetailsResponse } from "../../api-models/response/StructureDetailsResponse";
import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { BaseTechnicalInspection } from "../technical-inspection/BaseTechnicalInspection";

export class StructureDetails extends BaseTechnicalInspection {
  id: number;
  name: string;
  dataOwner: string;
  project: NameEntityResponse;
  created: Date;
  createdBy: NameEntityResponse;
  modifiedBy: NameEntityResponse;
  openJobs: number;
  hasGeometry: boolean;
  canDelete: boolean;

  constructor(structure?: StructureDetailsResponse) {
    if (structure) {
      super(structure.dynamicProperties, structure.genericIssues);
      this.id = structure.id;
      this.name = structure.name;
      this.dataOwner = structure.dataOwner;
      this.project = structure.project;
      this.created = structure.created;
      this.modifiedBy = structure.modifiedBy;
      this.createdBy = structure.createdBy;
      this.openJobs = structure.openJobs;
      this.hasGeometry = structure.hasGeometry;
      this.canDelete = structure.canDelete;
    } else {
      super([], []);
      this.id = 0;
      this.name = "";
      this.dataOwner = "";
      this.created = new Date();
      this.createdBy = { id: 0, name: "", isDeleted: false };
      this.modifiedBy = { id: 0, name: "", isDeleted: false };
      this.project = { id: 0, name: "", isDeleted: false };
      this.openJobs = 0;
      this.hasGeometry = false;
      this.canDelete = false;
    }
  }
}
